import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = {
    url: String
  }

  async select(event) {
    const code = event.currentTarget.value
    if (!code || !this.hasUrlValue) return

    const token = document.querySelector("meta[name='csrf-token']")?.content
    const body = new URLSearchParams()
    body.append("payment_method", code)

    const response = await fetch(this.urlValue, {
      method: "POST",
      headers: {
        "Accept": "text/vnd.turbo-stream.html",
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        ...(token ? { "X-CSRF-Token": token } : {})
      },
      body: body.toString(),
      credentials: "same-origin"
    })

    const html = await response.text()
    if (response.ok) {
      Turbo.renderStreamMessage(html)
    }
  }
}
